import {FILES_UPLOAD_FAILED,UPDATE_FILES_UPLOAD_PROGRESS,FILES_UPLOADED} from 'Constants';

export function UploadContentFileProgressReducer(state=0,action){
  switch (action.type) {
    case UPDATE_FILES_UPLOAD_PROGRESS:
        return action.payload;
    default:
        return state;
  }
}

export function UploadContentFileFailedReducer(state=false,action){
  switch (action.type) {
    case FILES_UPLOAD_FAILED:
        return action.payload;
    default:
        return state;
  }
}

export function UploadContentFileUploadedReducer(state={},action){
  switch (action.type) {
    case FILES_UPLOADED:
        return action.payload;
    default:
        return state;
  }
}
